<template>
  <body>
    <div class="body">
        <div class="top">
          <img src="images/basic/img/copy.svg" alt="">
          <div class="btns">
              <a href="#"><img src="images/basic/img/ios.png" alt=""></a>
              <a href="https://play.google.com/store/apps/details?id=biz.thehae.app"><img src="images/basic/img/aos.png" alt=""></a>
          </div>
        </div>
        <div class="bottom"></div>
    </div>
  </body>
</template>

<script>
import Vue from 'vue';
import VueHead from 'vue-head';
Vue.use(VueHead);
export default {
  head: {
    title: {
      inner: '더해-블록체인 커뮤니티 플랫폼'
    },
    meta: [
      { charset: 'UTF-8' },
      { name: 'viewport', content: '"width=device-width, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, user-scalable=no, viewport-fit=cover' },
      { name: 'apple-mobile-web-app-title', content: '더해' },
      { name: 'apple-mobile-web-app-capable', content: 'yes' },
      { name: 'msapplication-TileColor', content: '#ffffff' },
      { name: 'theme-color', content: '#ffffff' },
      { name: 'msapplication-TileImage', content: '/ms-icon-144x144.png' },
      { name: 'apple-mobile-web-app-status-bar-style', content: 'default' },
      { property: 'og:url"', content: 'https://app.thehae.biz/gate' },
      { property: 'og:title"', content: '더해' },
      { property: 'og:type"', content: 'website' },
      { property: 'og:width"', content: '600' },
      { property: 'og:height"', content: '600' },
      { property: 'og:image"', content: 'https://app.thehae.biz/images/invite_image.png' },
      { property: 'og:description"', content: '즐거움과 혜택이 더해지는 커뮤니티 플랫폼' },
    ],
  },
}
</script>

<style scoped>
     html,
      body {
         height: 100vh;
      }
      body {
         background: url("../../../public/images/basic/img/bg.jpg") no-repeat center;
         background-size: cover;
         margin: 0;
         padding: 0;
      }
      .body {
         display: flex;
         align-items: flex-start;
         justify-content: center;
         height: 100%;
      }
      .top {
         text-align: center;
         height: 40vh;
         display: flex;
         align-items: center;
         flex-direction: column;
         justify-content: center;
      }
      .top img {
         height: 150px;
      }
      .btns {
         margin-top: 4vh;
      }
      .btns a img {
         max-height: 60px;
      }
      @media (min-width: 280px) and (max-width: 767px) {
         .btns a img {
            height: 40px;
         }
         .top img {
            height: initial;
         }
      }
</style>